import { STAGE_COLORS, PROPERTY_STATUS } from "@/lib/meta";
import { useStages } from "@/lib/stages";
import { cn } from "@/lib/utils";

export function StageBadge({ stage, className }) {
  const { labels } = useStages();
  return (
    <span data-testid={`stage-badge-${stage}`}
      className={cn("inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold", STAGE_COLORS[stage] || "bg-gray-100 text-gray-700 border-gray-200", className)}>
      {labels[stage] || stage}
    </span>
  );
}

export function StatusBadge({ status }) {
  const s = PROPERTY_STATUS[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-200" };
  return (
    <span data-testid={`status-badge-${status}`}
      className={cn("inline-flex items-center rounded border px-2 py-0.5 text-xs font-semibold", s.cls)}>
      {s.label}
    </span>
  );
}
